// extracted by mini-css-extract-plugin
export default {"wrapper":"VerticalDataDescriptions_wrapper__AoTKJ","formItemVariant":"VerticalDataDescriptions_formItemVariant__XmoGo"};